import { render } from "./Notificacoes.vue?vue&type=template&id=2511cd13&scoped=true&ts=true"
import script from "./Notificacoes.vue?vue&type=script&lang=ts"
export * from "./Notificacoes.vue?vue&type=script&lang=ts"

import "./Notificacoes.vue?vue&type=style&index=0&id=2511cd13&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2511cd13"]])

export default __exports__